import { render, staticRenderFns } from "./FormAssessmentGroups.vue?vue&type=template&id=95a4d7ee"
import script from "./FormAssessmentGroups.vue?vue&type=script&lang=js"
export * from "./FormAssessmentGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95a4d7ee')) {
      api.createRecord('95a4d7ee', component.options)
    } else {
      api.reload('95a4d7ee', component.options)
    }
    module.hot.accept("./FormAssessmentGroups.vue?vue&type=template&id=95a4d7ee", function () {
      api.rerender('95a4d7ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormAssessmentGroups.vue"
export default component.exports